import React, { useRef, useState, useEffect, useContext } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { CourseContext } from '../context/CourseContext';
import { Is_Login } from '../helper/IsLogin';
import { useTranslation } from 'react-i18next';
import '../i18n'; // important to import

const CourseSidebar = ({ name, type, token ,is_bookmarked ,course_id}) => {
 const { t } = useTranslation('CourseSidebar');

  const { manageBookMark, setIsWishlist, isWishlist } = useContext(CourseContext);
  const [showModal, setShowModal] = useState(false);
  const [showMain1, setShowMain1] = useState(true);
  const navigate = useNavigate()
  const isLoggedIn = Is_Login();

  const handleOpenModal = () => {
    setShowModal(true);
    setShowMain1(true);
  };

  const handleTalkBtnClick = () => {
    setShowMain1(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  const bookMark = () => {
    if (!isLoggedIn) {
      navigate("/sign-in");
    } else {
      manageBookMark(course_id);
    }
  };
  
     useEffect(() => {
      setIsWishlist(is_bookmarked);
     }, [is_bookmarked]);



  return (
    <>
      <div className="card border-0 position-lg-sticky">
        <div className="card-body p-0">
          <Accordion className='course-accordion' defaultActiveKey="0">
            <Accordion.Item className='accordion-item border-0 py-0' eventKey="0">
              <Accordion.Header>
                {name}
              </Accordion.Header>
              <Accordion.Body className='p-0'>
                <ul className="course-list-menu ps-0">
                  <li className={`row align-items-center gx-0 px-4 py-4 ${type == "Free" && "active"} `} >
                    <div className="col-8 col-md-9 col-xl-9 pe-3">
                      <Link to="" className="d-flex align-items-center">
                        <div>
                          <b className="text-black fs-6">{t("free")}  :</b>
                          <span className="fs-7 fw-400 text-black">
                          {t("takethecoursefor")}
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-4 col-md-3 col-xl-3">
                      <span className="badge badge-light text-black rounded-2 fw-400 fs-7 w-100">
                        {t("free")}
                      </span>
                    </div>
                  </li>
                  <li className={`row align-items-center gx-0 px-4 py-4 ${type == "Bronze" && "active"} `} >
                    <div className="col-8 col-md-9 col-xl-9 pe-3">
                      <Link to="" className="d-flex align-items-center">
                        <div>
                          <b className="text-black fs-6">{t("bronze")} :</b>
                          <span className="fs-7 fw-400 text-black">
                           {t("takethecourseforfreeasoneofourmembers")}
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-4 col-md-3 col-xl-3">
                      <span className="badge badge-bronze rounded-2 fw-400 fs-7 w-100">
                        {t("bronze")}
                      </span>
                    </div>
                  </li>
                  <li className={`row align-items-center gx-0 px-4 py-4 ${type == "Silver" && "active"} `} >
                    <div className="col-8 col-md-9 col-xl-9 pe-3">
                      <Link to="" className="d-flex align-items-center">
                        <div>
                          <b className="text-black fs-6">{t("silver")} :</b>
                          <span className="fs-7 fw-400 text-black">
                            {t("takethecourseforfreeasoneofourmembers")}
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-4 col-md-3 col-xl-3">
                      <span className="badge badge-silver rounded-2 fw-400 fs-7 w-100">
                        {t("silver")}
                      </span>
                    </div>
                  </li>
                  <li className={`row align-items-center gx-0 px-4 py-4 ${type == "Gold" && "active"} `} >
                    <div className="col-8 col-md-9 col-xl-9 pe-3">
                      <Link to="" className="d-flex align-items-center">
                        <div>
                          <b className="text-black fs-6">{t("gold")} :</b>
                          <span className="fs-7 fw-400 text-black">
                          {t("takethecourseforfreeasoneofourmembers")}
                          
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-4 col-md-3 col-xl-3">
                      <span className="badge badge-gold rounded-2 fw-400 fs-7 w-100">
                        {t("gold")}
                      </span>
                    </div>
                  </li>
                </ul>
                <button className="btn-primary w-100 text-center fw-400 fs-7 px-5">
                  {t("endes1")}
                </button>
                <button className="btn-primary bg-black w-100 text-center fw-400 fs-7 px-5" id="Btn-Open-model" onClick={handleOpenModal}>
                 {t("endes2")}
                </button>
                <div className="px-4 py-5 border-bottom border-secondary">
                  <span className="text-primary fw-500 fs-6">
                    {t("jointhelearningadventure")}
                  </span>
                  <h4 className="fw-400 mt-3 text-black">
                   {t("creatinganaccountisquickeasyandcompletelyfree")}
                  </h4>
                  <p className="text-black fw-400 fs-7 mt-4 pb-4">
                   {t("enddes3")}
                  </p>
                {!isLoggedIn &&
                  <Link to="/sign-up"
                    className="btn-primary rounded-2 w-auto"
                  >
                    {t("singup")}
                    <span className='ps-2'>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={22}
                        height={14}
                        viewBox="0 0 22 14"
                        fill="none"
                      >
                        <path
                          d="M1 6.99854H21L16 1"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 6.99805L16 12.9995"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>
                  </Link>
                }
              
                </div>
                <div className="px-4 py-5">
                  <span className="text-primary fw-500 fs-6">
                   {t("stayorganized")}
                  </span>
                  <h3 className="fw-400 mt-3 text-black-primary">
                   {t("savethiscourseforlater")}
                  </h3>
                  <p className="text-black-primary fw-400 fs-18 mt-4">
                    {t("bookingdes1")}
                  </p>
                  <button
                    type="button"
                    onClick={bookMark}
                    className={`${isWishlist ? "btn-explore" : "btn-primary"} d-flex align-items-center gap-3 rounded-2 mt-4`}
                  >
                   {isWishlist ? t("bookmarked") : t("bookmark") } 
                    <img
                      src= {isWishlist ?  "../featured-courses/bookmark_added4.png" : "../featured-courses/bookmark_added.png"} 
                      className="wh-25"
                      alt=""
                    />
                  </button>

                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} centered scrollable size="lg">
        <Modal.Header closeButton className="justify-content-end border-0 pb-0 talk-modal mt-2">
        </Modal.Header>
        <Modal.Body className="px-md-5 pb-md-5">
          {showMain1 ? (
            <div id="talk-div-main1">
              <div id="talk-div-main1">
                <p className="text-primary fs-7 fw-400">{t("bookaninspirationalspeaker")} </p>
                <h2 className="fw-400 mb-4">{t("letshaveinpirationaltalk")} </h2>
                <p className="fw-400 fs-6 text-bl">
                {t("bookingdes2")}
                </p>
                <form className="row gy-3 inspirational-talk-popup">
                  <div className="col-md-12">
                    <label
                      htmlFor="inputPassword4"
                      className="form-label text-bl fs-6 fw-400"
                    >
                     {t("name")}
                    </label>
                    <input className="form-control" id="Name" placeholder="Add Name" />
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="inputEmail4" className="form-label text-bl fs-6 fw-400">
                      {t("email")}
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="inputEmail4"
                      placeholder={t("email")}
                    />
                  </div>
                  <div className="col-12">
                    <label
                      htmlFor="inputAddress"
                      className="form-label text-bl fs-6 fw-400"
                    >
                      {t("companyororganization")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputAddress"
                      placeholder={t("aicminc")}
                    />
                  </div>
                  <div className="col-12">
                    <label
                      htmlFor="inputAddress"
                      className="form-label text-bl fs-6 fw-400"
                    >
                      {t("preferedcoursedeliverymethod")}
                    </label>
                    <div className="bg-secondary rounded-2">
                      <div className="d-flex justify-content-between align-items-center pe-2 op-select">
                        <div id="flip">{t("idliketoscheduleanonlinemeeting")} </div>
                        <i className="fa-solid fa-chevron-down text-primary" id="op-icon" />
                      </div>
                      <div className="option op-select">
                       {t("idliketohaveameetinginperson")}
                      </div>
                      <div className="option op-select">{t("ihaventdecidedyet")} </div>
                    </div>
                  </div>
                  <div className="col-12" id="location">
                    <label
                      htmlFor="inputAddress"
                      className="form-label text-bl fs-6 fw-400"
                    >
                     {t("letusknowthelocation")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputAddress"
                      placeholder={t("poboxmunichgermany")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label text-bl fs-6 fw-400">
                     {t("anyfurtherwishes")}
                    </label>
                    <div className="form-floating">
                      <textarea
                        className="form-control rows pt-3"
                        placeholder={t("need1hrsession")}
                        id="floatingTextarea2"
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex justify-content-start">
                      <button id="talk-btn" className="btn-primary btn-light-warning text-black rounded-2 mt-4 fw-600" onClick={handleTalkBtnClick}>
                        {t("letstalk")}
                        <span className='ps-3'>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={22}
                            height={14}
                            viewBox="0 0 22 14"
                            fill="none"
                          >
                            <path
                              d="M1 6.99854H21L16 1"
                              stroke="#000C2A"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M21 6.99805L16 12.9995"
                              stroke="#000C2A"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />
                          </svg>
                        </span>

                      </button>
                    </div>
                  </div>
                </form>


              </div>
            </div>
          ) : (
            <div id="talk-div-main2">
              <p className="text-primary fs-7 fw-400 text-center">
              {t("bookaninspirationalspeaker")}
              </p>
              <div className="d-flex justify-content-center">
                <img
                  src="../gif/talk.gif"
                  className="talk-gif mb-4"
                  alt=""
                />
              </div>
              <h2 className="fw-400 text-black text-center">{t("thankyou")} </h2>
              <p className="fs-16 fw-400 text-black text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={13}
                  height={14}
                  viewBox="0 0 13 14"
                  fill="none"
                >
                  <circle cx="6.5" cy={7} r="6.5" fill="#D2E23D" />
                  <path
                    d="M5.30155 8.68181L3.49189 6.87086L2.88867 7.47451L5.30155 9.88911L10.472 4.71498L9.86879 4.11133L5.30155 8.68181Z"
                    fill="#000C2A"
                  />
                </svg>
              {t("wereceivedyourrequestwewillgetbacktoyouassoonaspossible")}
              </p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CourseSidebar